"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "truncate", {
  enumerable: true,
  get: function get() {
    return _truncate.truncate;
  }
});
var _truncate = require("./truncate");